import { Injectable } from '@angular/core';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';
import { HeatmapDataObj } from './heatmap.model'

@Injectable({
  providedIn: 'root'
})
export class HeatmapService {

    constructor(
        private cvApiService: CVApiService
    ) { }

    public async LoadData(moduleKey: string, isAutoRefresh?:boolean, isFirstLoad?:boolean) {
        let renderEndPoint: string;
        try {
            renderEndPoint = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
        } catch (error) {
            console.error("Failed getting module render end point.");
            throw error;
        }
        try {
            const url = "/api/v2/dashboards/modules/geotagdata/" + moduleKey + "?isAutoRefresh=" + !!isAutoRefresh + "&isFirstLoad=" + !!isFirstLoad;
            const response = await this.cvApiService.get<HeatmapDataObj>(url, renderEndPoint);
            if (response.status_code >= 200 && response.status_code < 300) {
                return response.data;
            }
            else {
                throw response;
            }
        } catch (error) {
            console.error("Failed getting heatmap data");
            throw error;
        }
    }
}
